/**
 * @voltxampere/engine — SPI bus DC stamp (Sprint 48-3)
 *
 * Per ADR-0069 — Engine extension #5 (second half). The `spi-bus`
 * canonical type is a topological connector node: like `i2c-bus`
 * (Sprint 48-2), DC stamp body is a no-op. Bus state machine (8-bit
 * MOSI/MISO shift register, mode 0 MVP) lives in `./spi-bus-fsm.ts`.
 *
 * Sprint 48-3 MVP scope:
 *
 *   - DC stamp is no-op (no Y/B/C/rhs contribution).
 *   - 4-wire (MOSI + MISO + SCK + CS_n) topology.
 *   - Mode 0 only (CPOL=0, CPHA=0; sample rising, drive falling).
 *   - 8-bit MSB-first shift register per slave.
 *   - Multi-slave via per-CS active-low gating.
 *
 * Out of scope (Sprint 50+):
 *
 *   - Mode 1/2/3 (CPHA=1 or CPOL=1)
 *   - LSB-first bit order (additive parameter, schema validates)
 *   - Real cycle-accurate SCK edge sampling (transient simulation)
 *   - DMA / FIFO double-buffering
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { defineDCStamp } from "./definition.js";
/**
 * The SPI bus stamp — no-op DC contribution. Topological routing
 * only. Master + slaves drive their own pin voltages outside the
 * Newton loop; the bus FSM helper (`SpiBusFsm`) coordinates the
 * 8-bit shift exchanges between master and addressed slave.
 */
export const spiBusDCStamp = (_ctx, _component) => {
    // No MNA contribution. SPI is a logical bus — slaves and master
    // each drive their own pins, the bus stamp just claims the type.
};
/**
 * SPI bus stamp definition. No augmentation, no junction terminals.
 * Like `i2c-bus`, the planner registers the type so placing an
 * `spi-bus` component is valid; activation upgrades only touch the
 * stamp body.
 */
export const spiBusDCStampDefinition = defineDCStamp("spi-bus", spiBusDCStamp, []);
//# sourceMappingURL=spi-bus.js.map